import { render } from "./CadFinancasDespesas.vue?vue&type=template&id=aafbb6ac"
import script from "./CadFinancasDespesas.vue?vue&type=script&lang=js"
export * from "./CadFinancasDespesas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__